import useSWR from 'swr';

const { REACT_APP_API_BASE_URL } = process.env;

const useRoles = () => {
  const url = `${REACT_APP_API_BASE_URL}/roles`;
  const { data, error, isLoading } = useSWR(url);

  return {
    roles: data,
    error,
    isLoading,
  };
};

export default useRoles;
